import { render, staticRenderFns } from "./Cleaning.vue?vue&type=template&id=061afbcd&scoped=true&"
import script from "./Cleaning.vue?vue&type=script&lang=js&"
export * from "./Cleaning.vue?vue&type=script&lang=js&"
import style0 from "./Cleaning.vue?vue&type=style&index=0&id=061afbcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061afbcd",
  null
  
)

export default component.exports